<script setup lang="ts">
/* A centred card on the dark palette. The customer app splits its auth
   screen into a brand panel and a form because it is selling something
   on the way in; nobody needs selling to here, so the whole screen is
   just the one thing you came to do. */
import { RouterView } from 'vue-router'
import Logo from '@/components/Logo.vue'
</script>

<template>
  <div class="wrap invert">
    <main class="card">
      <Logo :size="34" class="logo" />
      <RouterView />
    </main>
    <p class="foot">Internal tool · River Atlas staff only</p>
  </div>
</template>

<style scoped>
.wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--space-md);
  min-height: 100dvh;
  padding: var(--space-md);
  /* A faint horizon so the card has something to sit against. */
  background-image: radial-gradient(
    120% 90% at 50% 0%,
    color-mix(in srgb, var(--rv-teal-700) 22%, transparent),
    transparent 70%
  );
}

.card {
  width: min(24rem, 100%);
  display: flex;
  flex-direction: column;
  gap: var(--space-md);
  padding: var(--space-lg);
  background-color: var(--color-surface);
  border: var(--border-width) solid var(--color-border);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-lg);
}

.logo {
  align-self: flex-start;
}

.foot {
  font-size: var(--text-xs);
  letter-spacing: var(--tracking-wide);
  color: var(--color-text-faint);
}
</style>
